import React, { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/jwt';

const ProtectedRoute = () => {
  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const auth = await isAuthenticated();
      setIsAuth(auth);
    };

    checkAuth();
  }, []);

  if (isAuth === null) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  return isAuth ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
